import * as THREE from 'three';

export class CameraRig {
  private readonly offset = new THREE.Vector3(10, 14, 12);
  private readonly look = new THREE.Vector3();
  private readonly desired = new THREE.Vector3();
  private zoom = 1;

  constructor(private readonly camera: THREE.PerspectiveCamera) {
    this.camera.fov = 42;
    this.camera.near = 0.1;
    this.camera.far = 160;
    this.camera.updateProjectionMatrix();
  }

  /** Pull camera back as fields expand so new rings stay readable. */
  setWorldScale(fieldsLevel: number): void {
    this.zoom = 1 + fieldsLevel * 0.12;
    this.offset.set(10 * this.zoom, 14 * this.zoom, 12 * this.zoom);
    this.camera.fov = Math.min(48, 40 + fieldsLevel * 0.8);
    this.camera.updateProjectionMatrix();
  }

  snapTo(target: THREE.Vector3): void {
    this.desired.copy(target).add(this.offset);
    this.camera.position.copy(this.desired);
    this.look.copy(target);
    this.look.y += 0.4;
    this.camera.lookAt(this.look);
  }

  update(target: THREE.Vector3, dt: number, lag = 0.12): void {
    this.desired.copy(target).add(this.offset);
    this.camera.position.lerp(this.desired, 1 - Math.exp(-dt / Math.max(lag, 0.001)));
    this.look.lerp(target, 1 - Math.exp(-dt / Math.max(lag * 1.2, 0.001)));
    this.look.y = target.y + 0.4;
    this.camera.lookAt(this.look);
  }
}
